import { useState } from 'react';

interface PendingMove {
    columnId: string;
    token: symbol;
}

export interface PendingMoves {
    pendingMoves: Map<string, PendingMove>;
    inFlightAppointmentIds: Set<string>;
    registerMove: (appointmentId: string, columnId: string) => symbol;
    clearMove: (appointmentId: string, token: symbol) => void;
}

export const usePendingMoves = (): PendingMoves => {
    const [pendingMoves, setPendingMoves] = useState<Map<string, PendingMove>>(new Map());

    const registerMove = (appointmentId: string, columnId: string): symbol => {
        const token = Symbol(appointmentId);
        setPendingMoves((prev) => {
            const next = new Map(prev);
            next.set(appointmentId, { columnId: columnId, token: token });
            return next;
        });
        return token;
    };

    const clearMove = (appointmentId: string, token: symbol): void => {
        setPendingMoves((prev) => {
            if (prev.get(appointmentId)?.token !== token) return prev;
            const next = new Map(prev);
            next.delete(appointmentId);
            return next;
        });
    };

    const inFlightAppointmentIds = new Set(pendingMoves.keys());

    return {
        pendingMoves: pendingMoves,
        inFlightAppointmentIds: inFlightAppointmentIds,
        registerMove: registerMove,
        clearMove: clearMove,
    };
};
